export const annaLobocka = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta dzieci i młodzieży Anna Łobocka',
        'description': 'Jestem psychologiem w trakcie czteroletniej szkoły psychoterapii poznawczo-behawioralnej w Warszawie. W swojej pracy łączę różne nurty psychoterapii.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-psychoterapeuta-anna-lobocka/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/anna-lobocka.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy, Psychoterapeuta w Bydgoszczy Anna Łobocka'
        }
    }
}